var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 11.7955V10.5955M11.9999 11.7955V9.39551M16.7999 11.7955V6.99551M9.5999 16.5955L7.7999 21.3955M16.5935 21.3288L14.4722 16.6619M4.7999 16.5955C3.47442 16.5955 2.3999 15.521 2.3999 14.1955V5.79551C2.3999 4.47002 3.47442 3.39551 4.7999 3.39551H19.1999C20.5254 3.39551 21.5999 4.47002 21.5999 5.79551V14.1955C21.5999 15.521 20.5254 16.5955 19.1999 16.5955H4.7999Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWidth2);
export default __webpack_public_path__ + "static/media/dashboard-width-2.7ebc0e4143ac7e99a0b05adb8a523390.svg";
export { ForwardRef as ReactComponent };